const seasonFilterStyles = {
  formControl: {
    minWidth: 200,
  },
}

export default seasonFilterStyles
